const LANG_KEY = 'freejini_lang';

export const LANGUAGES = [
  { code: 'en', label: 'English', flag: '🇺🇸' },
  { code: 'zh', label: '中文',    flag: '🇨🇳' },
  { code: 'ms', label: 'Melayu',  flag: '🇲🇾' },
];

export const getLang = () => localStorage.getItem(LANG_KEY) || 'en';
export const saveLang = (code) => localStorage.setItem(LANG_KEY, code);

const T = {
  // ── Tabs ──
  overview:       { en: 'Overview',      zh: '概览',       ms: 'Ringkasan'     },
  fundamentals:   { en: 'Fundamentals',  zh: '基本面',     ms: 'Asas'          },
  valuation:      { en: 'Valuation',     zh: '估值',       ms: 'Penilaian'     },
  technical:      { en: 'Technical',     zh: '技术分析',   ms: 'Teknikal'      },
  dividend:       { en: 'Dividend',      zh: '股息',       ms: 'Dividen'       },
  aiInsight:      { en: 'AI Insight',    zh: 'AI 洞察',    ms: 'Pandangan AI'  },
  peers:          { en: 'Peers',         zh: '同行比较',   ms: 'Rakan Sejawat' },
  news:           { en: 'News',          zh: '新闻',       ms: 'Berita'        },
  trading:        { en: 'Trading',       zh: '交易策略',   ms: 'Dagangan'      },
  holdings:       { en: 'Holdings',      zh: '持仓',       ms: 'Pegangan'      },
  moat:           { en: 'Economic Moat', zh: '护城河',     ms: 'Parit Ekonomi' },

  // ── Sidebar ──
  watchlist:      { en: 'Watchlist',     zh: '自选股',     ms: 'Senarai Pantau'},
  searchPlaceholder: { en: 'Search ticker or name...', zh: '搜索股票代码或名称...', ms: 'Cari ticker atau nama...' },
  noStocks:       { en: 'No stocks added yet', zh: '暂无自选股', ms: 'Tiada saham ditambah' },
  signOut:        { en: 'Sign Out',      zh: '退出登录',   ms: 'Log Keluar'    },

  // ── Overview ──
  marketCap:      { en: 'Market Cap',    zh: '市值',       ms: 'Had Pasaran'   },
  peRatio:        { en: 'P/E Ratio',     zh: '市盈率',     ms: 'Nisbah P/E'    },
  eps:            { en: 'EPS (TTM)',     zh: '每股盈利',   ms: 'EPS (TTM)'     },
  weekRange:      { en: '52W Range',     zh: '52周范围',   ms: 'Julat 52M'     },
  fairValue:      { en: 'Fair Value',    zh: '合理价值',   ms: 'Nilai Saksama' },
  verdict:        { en: 'Verdict',       zh: '结论',       ms: 'Keputusan'     },
  dcf:            { en: 'DCF',           zh: 'DCF估值',    ms: 'DCF'           },
  fcfYield:       { en: 'FCF Yield',     zh: '自由现金流收益', ms: 'Hasil FCF' },
  trend:          { en: 'Trend',         zh: '趋势',       ms: 'Trend'         },
  rsi:            { en: 'RSI',           zh: 'RSI指标',    ms: 'RSI'           },
  about:          { en: 'About',         zh: '公司简介',   ms: 'Tentang'       },

  // ── Fundamentals ──
  annualFinancialComparison: { en: 'Annual Financial Comparison', zh: '年度财务对比', ms: 'Perbandingan Kewangan Tahunan' },
  incomeStatement:{ en: 'Income Statement', zh: '损益表',   ms: 'Penyata Pendapatan' },
  margins:        { en: 'Margins',       zh: '利润率',     ms: 'Margin'         },
  revenue:        { en: 'Revenue',       zh: '营业收入',   ms: 'Hasil'         },
  revenueGrowth:  { en: 'Revenue Growth', zh: '收入增长',  ms: 'Pertumbuhan Hasil' },
  grossProfit:    { en: 'Gross Profit',  zh: '毛利润',     ms: 'Keuntungan Kasar' },
  operatingIncome:{ en: 'Operating Income', zh: '营业利润', ms: 'Pendapatan Operasi' },
  netIncome:      { en: 'Net Income',    zh: '净利润',     ms: 'Pendapatan Bersih' },
  netIncomeGrowth:{ en: 'Net Income Growth', zh: '净利润增长', ms: 'Pertumbuhan Pendapatan Bersih' },
  epsLabel:       { en: 'EPS',           zh: '每股收益',   ms: 'EPS'           },
  grossMargin:    { en: 'Gross Margin',  zh: '毛利率',     ms: 'Margin Kasar'  },
  operatingMargin:{ en: 'Operating Margin', zh: '营业利润率', ms: 'Margin Operasi' },
  netMargin:      { en: 'Net Margin',    zh: '净利润率',   ms: 'Margin Bersih' },
  revenueNetIncome: { en: 'Revenue & Net Income ($B)', zh: '营收与净利润（十亿美元）', ms: 'Hasil & Pendapatan Bersih ($B)' },
  marginTrends:   { en: 'Margin Trends (%)', zh: '利润率趋势 (%)', ms: 'Trend Margin (%)' },
  profitabilityReturns: { en: 'Profitability & Returns', zh: '盈利能力与回报', ms: 'Keuntungan & Pulangan' },
  opMarginShort:  { en: 'Op. Margin',    zh: '营业利润率', ms: 'Margin Op.'    },
  roe:            { en: 'ROE',           zh: '净资产回报率', ms: 'ROE'          },
  roa:            { en: 'ROA',           zh: '总资产回报率', ms: 'ROA'          },
  evEbitda:       { en: 'EV/EBITDA',     zh: 'EV/EBITDA',  ms: 'EV/EBITDA'    },
  revGrowth:      { en: 'Rev Growth',    zh: '收入增长',   ms: 'Pertumbuhan Hasil' },
  epsGrowth:      { en: 'EPS Growth',    zh: '每股盈利增长', ms: 'Pertumbuhan EPS' },
  balanceSheet:   { en: 'Balance Sheet', zh: '资产负债表', ms: 'Kunci Kira-kira' },
  totalAssets:    { en: 'Total Assets',  zh: '总资产',     ms: 'Jumlah Aset'   },
  totalDebt:      { en: 'Total Debt',    zh: '总负债',     ms: 'Jumlah Hutang'  },
  cash:           { en: 'Cash',          zh: '现金',       ms: 'Tunai'         },
  equity:         { en: 'Equity',        zh: '股东权益',   ms: 'Ekuiti'        },
  deRatio:        { en: 'D/E Ratio',     zh: '负债权益比', ms: 'Nisbah D/E'    },
  currentRatio:   { en: 'Current Ratio', zh: '流动比率',   ms: 'Nisbah Semasa' },
  cashFlow:       { en: 'Cash Flow',     zh: '现金流',     ms: 'Aliran Tunai'  },
  operatingCF:    { en: 'Operating CF',  zh: '经营现金流', ms: 'CF Operasi'    },
  capex:          { en: 'CapEx',         zh: '资本支出',   ms: 'CapEx'         },
  freeCashFlow:   { en: 'Free Cash Flow', zh: '自由现金流', ms: 'Aliran Tunai Bebas' },
  dividendsPaid:  { en: 'Dividends Paid', zh: '已支付股息', ms: 'Dividen Dibayar' },
  metric:         { en: 'Metric',        zh: '指标',       ms: 'Metrik'        },

  // ── AI Insight ──
  aiInvestmentThesis: { en: 'AI Investment Thesis', zh: 'AI 投资分析', ms: 'Tesis Pelaburan AI' },
  generatedAgo:   { en: 'Generated', zh: '生成于', ms: 'Dijana' },
  priceAtGeneration: { en: 'Price at generation', zh: '生成时价格', ms: 'Harga semasa jana' },
  refresh:        { en: '↻ Refresh', zh: '↻ 刷新', ms: '↻ Muat Semula' },
  generateInsight: { en: 'Generate Insight', zh: '生成分析', ms: 'Jana Pandangan' },
  noSavedInsight: { en: 'No saved insight for', zh: '暂无分析报告：', ms: 'Tiada pandangan untuk' },
  clickToGenerate: { en: 'Click "Generate Insight" to analyse with AI.', zh: '点击"生成分析"以使用AI进行分析。', ms: 'Klik "Jana Pandangan" untuk analisis dengan AI.' },
  analysingWith:  { en: 'Analysing with Claude AI...', zh: '正在使用 Claude AI 分析...', ms: 'Menganalisis dengan Claude AI...' },
  priceTargetRange: { en: 'Price Target Range', zh: '目标价格区间', ms: 'Julat Sasaran Harga' },
  upsideToHigh:   { en: 'Upside to high target', zh: '距高目标上涨空间', ms: 'Kenaikan ke sasaran tinggi' },
  timeHorizon:    { en: 'Time Horizon', zh: '投资期限', ms: 'Horizon Masa' },
  bullCase:       { en: 'Bull Case', zh: '看涨理由', ms: 'Kes Positif' },
  bearCase:       { en: 'Bear Case', zh: '看跌理由', ms: 'Kes Negatif' },
  primaryRisk:    { en: '⚠ Primary Risk:', zh: '⚠ 主要风险：', ms: '⚠ Risiko Utama:' },
  regenerate:     { en: '↻ Regenerate with latest data', zh: '↻ 使用最新数据重新生成', ms: '↻ Jana Semula dengan Data Terkini' },
  verdictLabel:   { en: 'Verdict', zh: '结论', ms: 'Keputusan' },

  // ── Valuation ──
  currentPrice:   { en: 'Current Price', zh: '当前价格',   ms: 'Harga Semasa'  },
  fairValueEst:   { en: 'Fair Value Estimate', zh: '估计合理价值', ms: 'Anggaran Nilai Saksama' },
  marginOfSafety: { en: 'Margin of Safety', zh: '安全边际', ms: 'Margin Keselamatan' },
  undervalued:    { en: 'Undervalued',   zh: '被低估',     ms: 'Dinilai Rendah' },
  overvalued:     { en: 'Overvalued',    zh: '被高估',     ms: 'Dinilai Tinggi' },
  fairlyValued:   { en: 'Fairly Valued', zh: '合理估值',   ms: 'Nilai Saksama' },

  // ── Dividend ──
  annualYield:    { en: 'Annual Yield',  zh: '年化收益率', ms: 'Hasil Tahunan'  },
  annualRate:     { en: 'Annual Rate',   zh: '年化股息',   ms: 'Kadar Tahunan'  },
  payoutRatio:    { en: 'Payout Ratio',  zh: '派息比率',   ms: 'Nisbah Bayaran' },
  exDate:         { en: 'Ex-Date',       zh: '除息日',     ms: 'Tarikh Ex'      },
  payDate:        { en: 'Pay Date',      zh: '派息日',     ms: 'Tarikh Bayar'   },
  amount:         { en: 'Amount',        zh: '金额',       ms: 'Jumlah'         },
  noDividend:     { en: 'This stock does not pay a dividend.', zh: '该股票不派息。', ms: 'Saham ini tidak membayar dividen.' },

  // ── Technical ──
  daily:          { en: 'Daily',         zh: '日线',       ms: 'Harian'        },
  weekly:         { en: 'Weekly',        zh: '周线',       ms: 'Mingguan'      },
  monthly:        { en: 'Monthly',       zh: '月线',       ms: 'Bulanan'       },
  quarterly:      { en: 'Quarterly',     zh: '季线',       ms: 'Suku Tahunan'  },
  yearly:         { en: 'Yearly',        zh: '年线',       ms: 'Tahunan'       },
  resistance:     { en: 'Resistance',    zh: '阻力位',     ms: 'Rintangan'     },
  support:        { en: 'Support',       zh: '支撑位',     ms: 'Sokongan'      },
  crossSignal:    { en: 'Cross Signal',  zh: '交叉信号',   ms: 'Isyarat Silang' },
  keyLevels:      { en: 'Key Levels',    zh: '关键价位',   ms: 'Tahap Utama'   },
  technicalSignals: { en: 'Technical Signals', zh: '技术信号', ms: 'Isyarat Teknikal' },

  // ── Moat ──
  moat:           { en: 'Economic Moat', zh: '经济护城河', ms: 'Parit Ekonomi' },
  wideMoat:       { en: 'Wide Moat',    zh: '宽护城河',   ms: 'Parit Lebar'   },
  narrowMoat:     { en: 'Narrow Moat',  zh: '窄护城河',   ms: 'Parit Sempit'  },
  noMoat:         { en: 'No Moat',      zh: '无护城河',   ms: 'Tiada Parit'   },
  overallScore:   { en: 'Overall Score', zh: '综合评分',  ms: 'Skor Keseluruhan' },
  generateMoat:   { en: 'Generate Moat Analysis', zh: '生成护城河分析', ms: 'Jana Analisis Parit' },
  regenerateMoat: { en: '↻ Regenerate', zh: '↻ 重新生成', ms: '↻ Jana Semula' },
  moatAnalysing:  { en: 'Analysing competitive moat...', zh: '正在分析护城河...', ms: 'Menganalisis parit berdaya saing...' },
  noMoatData:     { en: 'No moat analysis yet. Click to generate.', zh: '暂无护城河分析，点击生成。', ms: 'Tiada analisis parit. Klik untuk jana.' },

  // ── Landing / Movers ──
  myWatchlist:    { en: 'My Watchlist',  zh: '我的自选股', ms: 'Senarai Saya'  },
  market:         { en: 'Market',        zh: '市场',       ms: 'Pasaran'       },
  dailyMovers:    { en: 'Daily Movers',  zh: '今日涨跌股', ms: 'Penggerak Harian' },
  topGainers:     { en: 'Top Gainers',   zh: '涨幅榜',     ms: 'Penaik Teratas' },
  topLosers:      { en: 'Top Losers',    zh: '跌幅榜',     ms: 'Penurun Teratas' },
  whyMoving:      { en: 'Why is it moving?', zh: '为什么在涨跌？', ms: 'Kenapa ia bergerak?' },
  clickBarToSee:  { en: 'Click any bar to see AI analysis', zh: '点击柱状图查看AI分析', ms: 'Klik bar untuk lihat analisis AI' },
  analysingMovement: { en: 'Analysing movement...', zh: '正在分析涨跌原因...', ms: 'Menganalisis pergerakan...' },
  noWatchlistStocks: { en: 'Add stocks to your watchlist to see movers here.', zh: '添加股票到自选股以查看涨跌。', ms: 'Tambah saham ke senarai pantau untuk lihat penggerak.' },
  relatedNews:    { en: 'Related News',  zh: '相关新闻',   ms: 'Berita Berkaitan' },
  openAnalysis:   { en: 'Open full analysis →', zh: '查看完整分析 →', ms: 'Buka analisis penuh →' },

  // ── Profile ──
  accountSettings: { en: 'Account Settings', zh: '账户设置', ms: 'Tetapan Akaun' },
  profileInfo:    { en: 'Profile Information', zh: '个人信息', ms: 'Maklumat Profil' },
  fullName:       { en: 'Full Name',     zh: '姓名',       ms: 'Nama Penuh'    },
  emailAddress:   { en: 'Email Address', zh: '电子邮件',   ms: 'Alamat E-mel'  },
  saveProfile:    { en: 'Save Profile',  zh: '保存',       ms: 'Simpan Profil' },
  changePassword: { en: 'Change Password', zh: '修改密码', ms: 'Tukar Kata Laluan' },
  currentPassword:{ en: 'Current Password', zh: '当前密码', ms: 'Kata Laluan Semasa' },
  newPassword:    { en: 'New Password',  zh: '新密码',     ms: 'Kata Laluan Baru' },
  confirmPassword:{ en: 'Confirm New Password', zh: '确认新密码', ms: 'Sahkan Kata Laluan Baru' },
  appearance:     { en: 'Appearance',    zh: '外观',       ms: 'Penampilan'    },
  language:       { en: 'Language',      zh: '语言',       ms: 'Bahasa'        },
  darkMode:       { en: 'Dark Mode',     zh: '深色模式',   ms: 'Mod Gelap'     },
  lightMode:      { en: 'Light Mode',    zh: '浅色模式',   ms: 'Mod Cerah'     },
};

export const t = (key, lang) => {
  const lang_ = lang || getLang();
  return T[key]?.[lang_] || T[key]?.en || key;
};

export default T;
